import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {Model} from "../Model";
import Order from "./Order";
import {OverviewData} from "./OverviewData";

@usingJsonToModelConvertor
export default class OrderAndOverviewData extends Model {

    @fromJsonObject({key: 'order', modelClass: Order, isArray: false})
    public order!: Order;

    @fromJsonObject({key: 'finalization_data', modelClass: OverviewData, isArray: false})
    public overViewData!: OverviewData;

}
